import * as types from "../actionTypes";

const INITIAL_STATE = {
    loading: false, data: null, message: '', error: null
}

const newReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {



        //NEW
        case types.CONTACT_NEW: {
            return {
                ...state,
                loading: true,
                data: action.payload,
                message: null,
                error: null
            }
        }
        case types.CONTACT_NEW_START: {
            return {
                ...state,
                loading: true,
                data: action.payload,
                message: null,
                error: null
            }
        }
        case types.CONTACT_NEW_SUCCESSFUL: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                message: 'Contatto creato correttamente',
                error: null
            }
        }
        case types.CONTACT_NEW_ERROR : {
            return {
                ...state,
                loading: false,
                data: null,
                message: null,
                error: action.payload
            }
        }
        case types.CONTACT_NEW_RESET  : {
            return {
                ...state,
                loading: false,
                data: null,
                message: null,
                error: null
            }
        }

        default:
            return state
    }

}

export default newReducer;